import { render, staticRenderFns } from "./createOverrideModalNew.vue?vue&type=template&id=05616218&scoped=true&"
import script from "./createOverrideModalNew.vue?vue&type=script&lang=js&"
export * from "./createOverrideModalNew.vue?vue&type=script&lang=js&"
import style0 from "./createOverrideModalNew.vue?vue&type=style&index=0&id=05616218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05616218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05616218')) {
      api.createRecord('05616218', component.options)
    } else {
      api.reload('05616218', component.options)
    }
    module.hot.accept("./createOverrideModalNew.vue?vue&type=template&id=05616218&scoped=true&", function () {
      api.rerender('05616218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/createOverrideModalNew.vue"
export default component.exports